import { MatTableDataSource } from "@angular/material/table";
import {
  AfterViewInit,
  Component,
  DestroyRef,
  Inject,
  ViewChild,
  inject,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { ServicesService } from "src/services/services.service";
import { MatSort } from "@angular/material/sort";
import { SelectionModel } from "@angular/cdk/collections";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ToastrService } from "ngx-toastr";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { NgxSpinnerService } from "ngx-spinner";
import { finalize } from "rxjs/operators";
import { Router } from "@angular/router";
import { DatePipe, Location } from "@angular/common";
import { SocketService } from "src/services/socket.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import jsPDF from "jspdf";
import { firstValueFrom } from "rxjs";
import { ProgressState, WhatsappProgressService } from "src/services/whatsapp-progress.service";

export interface PendingCardData {
  data: any;
}

export interface RegData {
  reg_id: any;
}

export interface EventElement {
  reg_id: string;
  mem_id: string;
  name: string;
  mobile: string;
  city: string;
  whatsapp_status: string;
  idCard: string;
  event_id: any;
  image: any;
  id_proof: any;
  state: any;
  address: any;
  email: any;
  field1: any;
  field2: any;
  field3: any;
  field4: any;
  field5: any;
  field6: any;
  field7: any;
  field8: any;
  field9: any;
  field10: any;
  field11: any;
  field12: any;
  field13: any;
  field14: any;
  field15: any;
  field16: any;
  field17: any;
  field18: any;
  field19: any;
  field20: any;
  field21: any;
  field22: any;
  field23: any;
  field24: any;
  field25: any;
  barcode: any;
  payment_ss: any;
  payment_status: any;
  transaction_id: any;
  coupon_code: any;
  allowed_person: any;
  reg_date: any;
  category: any;
  card_exists: any;
  tic_category: any;
  is_checked_in: any;
  is_approved: any;
  time: any;
  created_via: any;
  wamid: any;
}

@Component({
  selector: "app-registration-list",
  templateUrl: "./registration-list.component.html",
  styleUrls: ["./registration-list.component.scss"],
  standalone: false,
})
export class RegistrationListComponent {
  displayedColumns: string[] = [
    "select",
    // 'mem_id',
    // 'action',
    // 'image',
    // 'id_proof',
    // 'name',
    // 'mobile',
    // 'allowed_person',
    // 'city',
    // 'state',
    // 'address',
    // 'field1',
    // 'field2',
    // 'field3',
    // 'field4',
    // 'field5',
    // 'field6',
    // 'field7',
    // 'field8',
    // 'field9',
    // 'barcode',
    // 'payment_status',
    // 'payment_ss',
    // 'transaction_id',
    // 'coupon_code',
    // 'reg_date',
    // // 'whatsapp_status',
    // 'send_whatsapp',
  ];

  ELEMENT_DATA: EventElement[] = [];
  event_result: any;
  user_id: any;
  yesCount: number = 0;
  noCount: number = 0;
  totalCount: number = 0;
  report_type: any = "all";

  progress = 0;
  processed = 0;
  remaining = 0;
  skipped = 0;
  isProcessing = false;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<EventElement>();
  selection = new SelectionModel<EventElement>(true, []);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  unsend_card: any;
  event_data: any;
  event_id: any;
  event_image: any;
  Reg_Setting_data: any;
  mem_id: any;
  getresult: any;
  message: any;
  result: any;
  isUploading: boolean = false;
  isOld1: boolean = false;
  scanning_data: any;
  point: any;
  setting_data: any;
  contact_privacy: any;

  showImage: boolean = false;
  showIdProof: boolean = false;
  showPaymentSS: boolean = false;
  filteredData: EventElement[] = [];

  loading: boolean = false;

  last_reg_id: any | null = null;
  passExists: any;
  passNotExists: any;

  progressState!: ProgressState;

  constructor(
    private service: ServicesService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private router: Router,
    private location: Location,
    private socketservice: SocketService,
    private progressService: WhatsappProgressService,
  ) {
    this.socketservice.Refresh().subscribe((action: boolean) => {
      if (action === true) {
        this.fetchLatestAndUpdate();
      }
    });
  }

  ngOnInit() {
    this.initSocket();
    this.event_id = window.sessionStorage.getItem("Event_ID");

    this.service.checkCard(this.event_id).subscribe({
      next: (data: any) => {
        this.unsend_card = data.result;

        // ✅ ONLY NOW fetch registrations
        this.Get_Report(this.report_type);
      },
      error: () => {
        // fallback still load data
        this.Get_Report(this.report_type);
      }
    });

    this.Get_Reg_Setting();
    this.Get_Scanning_Point();

    this.progressService.progress$.subscribe((state) => {
      this.progressState = state;

      if (!state.isProcessing && state.progress === 100) {
        setTimeout(() => {
          this.progressService.reset();
        }, 3000); // hide after 3 sec
      }
    });
  }

  initSocket() {
    this.socketservice.Refresh()
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe(() => {
        this.fetchLatestAndUpdate();
      });
  }

  ngAfterViewInit() {
    this.Get_Report(this.report_type);
    this.dataSource.paginator = this.paginator;
    this.event_id = window.sessionStorage.getItem("Event_ID");
    this.Get_Event_By_Id(this.event_id);

  }

  addReg() {
    const dialogRef = this.dialog.open(add_registration, {
      data: {
        reg_id: "",
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.Get_Report(this.report_type);
    });
  }

  editReg(reg_id: any) {
    const dialogRef = this.dialog.open(EditRegistration, {
      data: {
        reg_id: reg_id,
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.Get_Report(this.report_type);
    });
  }

  printCard(event_id: any, mem_id: any) {
    const url = this.router
      .createUrlTree(["/idcard1", event_id, mem_id])
      .toString();
    const baseUrl = this.location.prepareExternalUrl(url);
    window.open(baseUrl, "_blank");
  }

  printTicket(event_id: any, mem_id: any) {
    const url = this.router
      .createUrlTree(["/idcard2", event_id, mem_id])
      .toString();
    const baseUrl = this.location.prepareExternalUrl(url);
    window.open(baseUrl, "_blank");
  }

  Send_Pending_Card() {
    const dataToSend = this.dataSource.data;

    const pendingData = dataToSend.filter(
      (item) =>
        item.whatsapp_status === "no" &&
        (item.payment_status === "captured" ||
          item.payment_status === "authorized" ||
          item.payment_status === "paid 0"),
    );

    const dialogRef = this.dialog.open(SendCard, {
      data: { dataSource: pendingData },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.Get_Report(this.report_type);
    });
  }

  Send_All() {
    const dataToSend = this.dataSource.data;

    const pendingData = dataToSend.filter(
      (item) =>
        item.payment_status === "captured" ||
        item.payment_status === "authorized" ||
        item.payment_status === "paid 0",
    );

    const dialogRef = this.dialog.open(SendCard, {
      data: { dataSource: pendingData },
      disableClose: true,
    });
  }

  Send_Whatsapp(element: any) {
    if (element.is_approved == 0) {
      alert("This Registration Not Approved Yet");
      return;
    }
    const Selected_User = Array.isArray(element) ? element : [element];
    const dialogRef = this.dialog.open(SendCard, {
      data: { dataSource: Selected_User },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.Get_Report(this.report_type);
    });
  }

  CashPay(mem_id: any) {
    const dialogRef = this.dialog.open(CashPay, {
      data: { dataSource: mem_id },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.Get_Report(this.report_type);
    });
  }

  Assign_Ticket(data: any) {
    const dialogRef = this.dialog.open(AssignTicket, {
      data: data,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.Get_Report(this.report_type);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    // Get the filtered data from the dataSource
    this.filteredData = this.dataSource.filteredData;
  }

  /** Whether the number of selected elements matches the total number of filtered rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows =
      this.filteredData.length > 0
        ? this.filteredData.length
        : this.dataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  /** Selects all filtered rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    const dataToSelect =
      this.filteredData.length > 0 ? this.filteredData : this.dataSource.data;
    this.selection.select(...dataToSelect);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: EventElement): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.mem_id}`;
  }

  /** Bulk Check-In for selected rows */
  bulkCheckIn() {
    const selectedRows = this.selection.selected;
    if (selectedRows.length === 0) {
      this.toastr.warning(
        "Please select at least one registration to check-in",
      );
      return;
    }

    if (!this.point) {
      this.toastr.error("Please select a Scanning Point");
      return;
    }

    const confirmAction = confirm(
      `Are you sure you want to check-in ${selectedRows.length} selected registrations?`,
    );

    if (!confirmAction) {
      return;
    }

    this.spinner.show();
    let completedCount = 0;
    let failedCount = 0;

    selectedRows.forEach((row) => {
      const data = {
        ...row,
        event_id: this.event_id,
        status: "checkin",
        point: this.point,
        created_via: "manual_admin"
      };

      this.service.docheckinout(data).subscribe(
        (response: any) => {
          if (response.flag === true) {
            completedCount++;
          } else {
            failedCount++;
          }

          if (completedCount + failedCount === selectedRows.length) {
            this.spinner.hide();
            if (completedCount > 0) {
              this.toastr.success(
                response.msg
              );
            }
            if (failedCount > 0) {
              this.toastr.error(response.msg);
            }
            this.selection.clear();
            this.Get_Report(this.report_type);
          }
        },
        (error: any) => {
          failedCount++;
          if (completedCount + failedCount === selectedRows.length) {
            this.spinner.hide();
            if (completedCount > 0) {
              this.toastr.success(
                `${completedCount} registration(s) checked-in successfully`,
              );
            }
            this.toastr.error("Some check-in operations failed");
            this.selection.clear();
            this.Get_Report(this.report_type);
          }
        },
      );
    });
  }

  /** Bulk Check-Out for selected rows */
  bulkCheckOut() {
    const selectedRows = this.selection.selected;
    if (selectedRows.length === 0) {
      this.toastr.warning(
        "Please select at least one registration to check-out",
      );
      return;
    }

    if (!this.point) {
      this.toastr.error("Please select a Scanning Point");
      return;
    }

    const confirmAction = confirm(
      `Are you sure you want to check-out ${selectedRows.length} selected registrations?`,
    );

    if (!confirmAction) {
      return;
    }

    this.spinner.show();
    let completedCount = 0;
    let failedCount = 0;

    selectedRows.forEach((row) => {
      const data = {
        ...row,
        event_id: this.event_id,
        status: "checkout",
        point: this.point,
        created_via: "manual_admin"
      };

      this.service.docheckinout(data).subscribe(
        (response: any) => {
          if (response.flag === true) {
            completedCount++;
          } else {
            failedCount++;
          }

          if (completedCount + failedCount === selectedRows.length) {
            this.spinner.hide();
            if (completedCount > 0) {
              this.toastr.success(
                `${completedCount} registration(s) checked-out successfully`,
              );
            }
            if (failedCount > 0) {
              this.toastr.error(`${failedCount} registration(s) failed`);
            }
            this.selection.clear();
            this.Get_Report(this.report_type);
          }
        },
        (error: any) => {
          failedCount++;
          if (completedCount + failedCount === selectedRows.length) {
            this.spinner.hide();
            if (completedCount > 0) {
              this.toastr.success(
                `${completedCount} registration(s) checked-out successfully`,
              );
            }
            this.toastr.error("Some check-out operations failed");
            this.selection.clear();
            this.Get_Report(this.report_type);
          }
        },
      );
    });
  }

  regFieldColumns: string[] = [];
  regFieldLabels: { [key: string]: string } = {};

  Get_Reg_Setting() {
    this.service.get_reg_setting(this.event_id).subscribe((res: any) => {
      // ✅ HANDLE BOTH API FORMATS
      const fields = Array.isArray(res)
        ? res
        : Array.isArray(res?.data)
          ? res.data
          : [];

      // reset flags
      this.showImage = false;
      this.showIdProof = false;
      this.showPaymentSS = false;

      this.regFieldColumns = [];
      this.regFieldLabels = {};

      fields.forEach((f: any) => {
        if (f.fields === "image") {
          this.showImage = f.hide_show === "1";
          return;
        }

        if (f.fields === "id_proof") {
          this.showIdProof = f.hide_show === "1";
          return;
        }

        if (f.fields === "payment_ss") {
          this.showPaymentSS = f.hide_show === "1";
          return;
        }

        const excludedFields = ["tic_category"];

        if (f.hide_show === "1" && !excludedFields.includes(f.fields)) {
          this.regFieldColumns.push(f.fields);
          this.regFieldLabels[f.fields] = f.label;
        }
      });

      console.log(this.regFieldColumns);

      this.regFieldColumns = this.regFieldColumns.filter(
        (c) => c !== "barcode",
      );

      this.displayedColumns = [
        "select",
        "mem_id",
        "is_approved",
        "check_status",
        "reg_date",
        ...(this.showImage ? ["image"] : []),
        ...(this.showIdProof ? ["id_proof"] : []),
        ...(this.showPaymentSS ? ["payment_ss"] : []),
        "allowed_person",
        "tic_category",
        ...this.regFieldColumns,
        "barcode",
        "payment_status",
        "transaction_id",
        "coupon_code",
        "created_via",
        "send_whatsapp",
        "action",
      ];
    });
  }

  isEditable(element: any): boolean {
    return true; // Just for now, we make it always editable
  }

  allowedPersonChange(element: any): void {
    // Handle the change when the user finishes editing
    // You can send the updated luggage value to your backend or update the local data
    element.activity_id = 0;

    // If needed, make an API call to save the data
    this.service
      .editAllowedPerson(element.reg_id, element.allowed_person)
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe({
        next: (val: any) => {
          this.toastr.success("Quantity Updated Successfully");
        },
        error: (err: any) => {
          console.error(err);
        },
      });
  }

  Get_Scanning_Point() {
    this.service.getpoints().subscribe((data: any) => {
      this.scanning_data = data.data;
    });
  }

  checkWhatsappStatus(wamid: any, reg_id: any) {
    console.log(wamid, reg_id);

    this.service.checkWhatsappStatus(wamid, reg_id).subscribe((data: any) => {
      this.event_data = data.data;
      this.event_id = this.event_data[0].event_id;
      this.event_image = this.event_data[0].event_image;
    });
  }

  Get_Report(report_type: any) {
    this.spinner.show();
    this.loading = true

    this.service.getsetting(this.event_id).subscribe((data: any) => {
      this.setting_data = data.data;
      this.contact_privacy = this.setting_data[0].contact_privacy;

      const User = sessionStorage.getItem("User");
      if (User == "superadmin") {
        this.contact_privacy = "public";
      }
    });

    this.service
      .getRegistrationData(this.event_id, '', '')
      .pipe(
        takeUntilDestroyed(this.destoryRef),
        finalize(() => this.loading = false),
      )
      .subscribe((data: any) => {
        this.ELEMENT_DATA = [];
        this.event_result = data.result;
        for (const item of this.event_result) {
          this.ELEMENT_DATA.push({
            reg_id: item.reg_id,
            mem_id: item.mem_id,
            id_proof:
              `https://aieventzo.com/upload/` +
              this.event_id +
              `/id_proof/` +
              item.id_proof,
            image:
              `https://aieventzo.com/upload/` +
              this.event_id +
              `/images/` +
              item.image,
            name: item.name,
            city: item.city,
            state: item.state,
            address: item.address,
            email: item.email,
            mobile: this.contact_privacy === "public" ? item.mobile : "",
            whatsapp_status: item.whatsapp_status || "no",
            idCard: item.whatsapp_status == "no" ? "pending" : "sent",
            field1: item.field1,
            field2: item.field2,
            field3: item.field3,
            field4: item.field4,
            field5: item.field5,
            field6: item.field6,
            field7: item.field7,
            field8: item.field8,
            field9: item.field9,
            field10: item.field10,
            field11: item.field11,
            field12: item.field12,
            field13: item.field13,
            field14: item.field14,
            field15: item.field15,
            field16: item.field16,
            field17: item.field17,
            field18: item.field18,
            field19: item.field19,
            field20: item.field20,
            field21: item.field21,
            field22: item.field22,
            field23: item.field23,
            field24: item.field24,
            field25: item.field25,
            barcode: item.barcode,
            payment_ss:
              `https://aieventzo.com/upload/` +
              this.event_id +
              `/payment_ss/` +
              item.payment_ss,
            payment_status: item.payment_status,
            transaction_id: item.transaction_id,
            coupon_code: item.coupon_code,
            allowed_person: item.allowed_person,
            reg_date: item.reg_date,
            time: item.time,
            card_exists: (item.card_exists === 'yes' || item.card_exists === 1 || item.card_exists === true) ? 'yes' : 'no',
            event_id: item.event_id,
            category: item.category,
            tic_category: item.tic_category,
            is_checked_in: item.is_checked_in,
            created_via: item.created_via,
            wamid: item.wamid,
            is_approved: (item.is_approved == 1 ? true : false),
          });
          this.spinner.hide();
          this.loading = false;
        }
        this.totalCount = this.ELEMENT_DATA.length;

        this.dataSource.data = this.ELEMENT_DATA;
        this.dataSource.filterPredicate = (data: any, filter: string) => {
          const normalizedFilter = filter.trim().toLowerCase();

          // 🔹 Default full row search (existing behavior)
          const fullDataString = Object.values(data).join(' ').toLowerCase();
          if (fullDataString.includes(normalizedFilter)) {
            return true;
          }

          // 🔹 Special logic ONLY for name
          const name = (data.name || '').toLowerCase();
          const searchTerms = normalizedFilter.split(' ').filter(term => term);

          return searchTerms.every(term => name.includes(term));
        };
        this.last_reg_id = this.ELEMENT_DATA[0]?.reg_id || null;
        console.log(this.last_reg_id);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.filteredData = [];
        this.selection.clear();
        this.yesCount = this.ELEMENT_DATA.filter(
          (item) => item.whatsapp_status === "yes",
        ).length;
        this.noCount = this.ELEMENT_DATA.filter(
          (item) => item.whatsapp_status === "no",
        ).length;

        this.passExists = this.ELEMENT_DATA.filter(
          (item) => item.card_exists == 'yes',
        ).length;
        this.passNotExists = this.ELEMENT_DATA.filter(
          (item) => item.card_exists == 'no',
        ).length;
      });
  }

  fetchLatestAndUpdate() {

    if (!this.last_reg_id) return;

    this.service.get_last_reports(this.event_id, this.last_reg_id)
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe((data: any) => {

        const newItems = data.result || [];
        if (!newItems.length) return;

        const mappedItems = newItems.map((item: any) => this.mapToElement(item));

        const combined = [...mappedItems, ...this.dataSource.data];

        // remove duplicates
        const map = new Map<string, EventElement>();
        for (const item of combined) {
          map.set(item.reg_id, item);
        }

        const finalData = Array.from(map.values());

        // 🔥 CRITICAL: enforce sort
        finalData.sort((a, b) => Number(b.reg_id) - Number(a.reg_id));

        this.dataSource.data = finalData;

        // correct cursor
        this.last_reg_id = Math.max(...finalData.map(x => Number(x.reg_id)));

        this.updateCounts();
      });
  }

  updateCounts() {
    const data = this.dataSource.data;

    this.totalCount = data.length;

    this.yesCount = data.filter(
      item => item.whatsapp_status === "yes"
    ).length;

    this.noCount = data.filter(
      item => item.whatsapp_status === "no"
    ).length;

    // ✅ FIX: add these
    this.passExists = data.filter(
      item => item.card_exists === 'yes'
    ).length;

    this.passNotExists = data.filter(
      item => item.card_exists === 'no'
    ).length;
  }

  mapToElement(item: any): EventElement {
    return {
      reg_id: item.reg_id,
      mem_id: item.mem_id,
      id_proof: `https://aieventzo.com/upload/${this.event_id}/id_proof/${item.id_proof}`,
      image: `https://aieventzo.com/upload/${this.event_id}/images/${item.image}`,
      name: item.name,
      city: item.city,
      state: item.state,
      address: item.address,
      email: item.email,
      mobile: this.contact_privacy === "public" ? item.mobile : "",
      whatsapp_status: item.whatsapp_status || "no",
      idCard: item.whatsapp_status == "no" ? "pending" : "sent",
      field1: item.field1,
      field2: item.field2,
      field3: item.field3,
      field4: item.field4,
      field5: item.field5,
      field6: item.field6,
      field7: item.field7,
      field8: item.field8,
      field9: item.field9,
      field10: item.field10,
      field11: item.field11,
      field12: item.field12,
      field13: item.field13,
      field14: item.field14,
      field15: item.field15,
      field16: item.field16,
      field17: item.field17,
      field18: item.field18,
      field19: item.field19,
      field20: item.field20,
      field21: item.field21,
      field22: item.field22,
      field23: item.field23,
      field24: item.field24,
      field25: item.field25,
      barcode: item.barcode,
      payment_ss: `https://aieventzo.com/upload/${this.event_id}/payment_ss/${item.payment_ss}`,
      payment_status: item.payment_status,
      transaction_id: item.transaction_id,
      coupon_code: item.coupon_code,
      allowed_person: item.allowed_person,
      event_id: item.event_id,
      reg_date: item.reg_date,
      time: item.time,
      category: item.category,
      is_approved: item.is_approved == 1,
      tic_category: item.tic_category,
      is_checked_in: item.is_checked_in,
      created_via: item.created_via,
      wamid: item.wamid,
      card_exists: (item.card_exists === 'yes' || item.card_exists === 1 || item.card_exists === true) ? 'yes' : 'no',
    };
  }

  onApprovalChange(element: any, event: any) {
    console.log(event);
    const is_approved = event == true ? 1 : 0;
    this.service
      .approve_registration(element.reg_id, is_approved)
      .subscribe((data: any) => {
        console.log(data);
      });
  }

  getTime(date: string, time: string) {
    return new Date(`${date} ${time}`);
  }

  getPaymentClass(status: string): string {
    switch ((status || "").toLowerCase()) {
      case "captured":
        return "pay-captured";

      case "failed":
        return "pay-failed";

      case "in_progress":
      case "in progress":
        return "pay-progress";

      default:
        return "pay-unknown";
    }
  }

  Get_Event_By_Id(event_id: any) {
    this.service.get_event_by_id(event_id).subscribe((data: any) => {
      this.event_data = data.data;
      this.event_id = this.event_data[0].event_id;
      this.event_image = this.event_data[0].event_image;
    });
  }

  async Create_Remaining_Card() {
    this.remaining = this.passNotExists;

    const buttonClicked = window.confirm("Sure You Want To Create?");
    if (!buttonClicked) return;

    this.progress = 0;
    this.isProcessing = true;

    this.spinner.show();

    try {
      let isDone = false;

      let totalProcessed = 0;
      let TOTAL = 0;

      while (!isDone) {
        const res: any = await firstValueFrom(
          this.service.Generate_Card_bulk(this.event_id, 'pending')
        );

        const batchProcessed = res?.processed || 0;

        totalProcessed += batchProcessed;

        this.remaining = res?.remaining ?? 0;
        this.skipped = res?.skipped || 0;

        // ✅ dynamically calculate TOTAL
        TOTAL = totalProcessed + this.remaining;

        this.processed = totalProcessed;

        this.progress = TOTAL > 0
          ? Math.round((totalProcessed / TOTAL) * 100)
          : 0;

        console.log({
          batch: res.processed,
          totalProcessed,
          remaining: this.remaining,
          TOTAL,
          progress: this.progress
        });

        isDone = res?.is_done;

        if (!isDone) {
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }

      this.isProcessing = false;
      this.progress = 100;

      this.toastr.success("All cards generated successfully!");
    } catch (err) {
      console.error(err);
      this.toastr.error("Something went wrong!");
    } finally {
      this.spinner.hide();
    }
  }

  async Create_All_Card() {
    const buttonClicked = window.confirm("Sure You Want To Create?");
    if (!buttonClicked) return;

    let generatedImageNames: string[] = [];

    this.progress = 0;
    this.isProcessing = true;
    this.spinner.show();

    try {
      let isDone = false;

      let TOTAL = 0;
      let totalProcessed = 0;

      while (!isDone) {

        const res: any = await firstValueFrom(
          this.service.Generate_Card_bulk(this.event_id, 'all')
        );

        const batchProcessed = res?.processed || 0;

        totalProcessed += batchProcessed;

        this.remaining = res?.remaining ?? 0;
        this.skipped = res?.skipped || 0;
        this.processed = totalProcessed;

        if (TOTAL === 0) {
          TOTAL = totalProcessed + this.remaining;
        }

        // ✅ CORRECT PROGRESS
        this.progress = TOTAL > 0
          ? Math.round((totalProcessed / TOTAL) * 100)
          : 0;

        console.log({
          batchProcessed,
          totalProcessed,
          remaining: this.remaining,
          progress: this.progress
        });

        isDone = res?.is_done;

        if (isDone && Array.isArray(res.image_names)) {
          generatedImageNames = res.image_names;
        }

        if (!isDone) {
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }

      this.progress = 100;
      this.isProcessing = false;

      this.toastr.success("All cards generated successfully!");
    } catch (err) {
      console.error(err);
      this.toastr.error("Something went wrong!");
    } finally {
      this.spinner.hide();
    }

    if (!generatedImageNames.length) return;

    const path = `/www/wwwroot/aieventzo.com/upload/${this.event_id}/pass/`;

    this.service
      .download_pass(generatedImageNames, path)
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe((data: any) => {
        const zipPath = data.zip_path;
        const downloadUrl = zipPath.replace(
          "/www/wwwroot/aieventzo.com",
          "https://aieventzo.com",
        );

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = "pass.zip";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setTimeout(() => {
        //   this.service.delete_zip(zipPath).subscribe();
        // }, 3000);

        this.toastr.success("Image Zip Downloaded Successfully.");
      });
  };


  previewCard(row: any) {
    const imageUrl = `https://aieventzo.com/upload/${row.event_id}/pass/${row.event_id}_${row.mem_id}.png`;
    window.open(imageUrl, '_blank');
  }

  downloadCard(row: any, type: "image" | "pdf") {
    console.log(row);

    const imageUrl = `https://aieventzo.com/upload/${row.event_id}/pass/${row.event_id}_${row.mem_id}.png`;

    if (type === "image") {
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = `${row.mem_id}_idcard.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    if (type === "pdf") {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = imageUrl;

      img.onload = () => {
        const pdf = new jsPDF("p", "mm", "a4");

        // A4 size in mm
        const pageWidth = 210;
        const pageHeight = 297;

        // Stretch image to full A4
        pdf.addImage(img, "PNG", 0, 0, pageWidth, pageHeight);
        pdf.save(`${row.event_id}_${row.mem_id}.pdf`);
      };
    }
  }

  DeleteReport(reg_id: any) {
    const buttonClicked = window.confirm(
      "Are You Sure To Delete This Registration?",
    );
    if (buttonClicked === true) {
      this.service
        .delete_registration(reg_id)
        .pipe(takeUntilDestroyed(this.destoryRef))
        .subscribe((data) => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(
            (item) => item.reg_id !== reg_id,
          );
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Registration Deleted Succesfully");
        });
    }
  }

  downloadFile(data: any, filename: string, contentType: string) {
    const blob = new Blob([data], { type: contentType });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  exportTable(type: any, dummy: any) {
    const data = {
      type: type,
      dummy: dummy,
    };
    this.service.export(data).subscribe(
      (response: any) => {
        this.downloadFile(response, "registration" + ".csv", "text/csv");
      },
      (error) => {
        console.error("Error exporting main member table:", error);
      },
    );
  }

  mainupload(files: any) {
    if (files.length == 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/csv\/*/) == null) {
      this.message = "Only CSV are supported.";
      return;
    }
    console.log(files);
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    this.isUploading = true;
    reader.onload = (_event) => {
      this.service.uploadcsvmat(files[0]).subscribe((data: any) => {
        this.result = data;
        this.isUploading = false;
        const csvfile = data["file_name"];
        this.service.ImportMember(csvfile).subscribe((data: any) => { });
        window.location.reload();
      });
    };
  }

  Manual_Scan(data: any, checkin: any) {
    if (!this.point) {
      alert("Please Select Scanning Point");
      return;
    }
    this.mem_id = data.id;
    data.event_id = this.event_id;
    data.status = checkin;
    data.point = this.point;
    data.created_via = "manual_admin";
    this.service.docheckinout(data).subscribe((data) => {
      this.getresult = data;
      if (this.getresult.flag == true) {
        this.toastr.success(this.getresult.msg);
        // this.Attendence_Result = [];
        // this.currentPage = 1;
        this.Get_Report(this.report_type);
      } else {
        // this.Get_Attendence();
        alert(this.getresult.msg);
        return;
      }
    });
  }

  Reports() {
    this.router.navigate(["/admin/Reports"]);
  }
}

@Component({
  selector: "edit_registration.html",
  templateUrl: "./edit_registration.html",
  standalone: false,
})
export class EditRegistration {
  UserForm: FormGroup;
  reg_id: any;
  user_name: any;
  user_mobile: any;
  user_pwd: any;
  role: any;
  is_active: any;
  result: any;
  event_id: any;
  main: any;
  whatsapp_status: any;
  Element_Data: any[] = [];
  private destoryRef = inject(DestroyRef);
  Reg_Setting_data: any;
  logofileURL!: string | ArrayBuffer | null;
  logoPath: any;
  imagefileURL!: any | ArrayBuffer;
  imgType!: any | ArrayBuffer;
  imagePath: any;
  message!: string;
  formData: any = {};
  minDate: any;
  maxDate: any;
  paymentPath: any = "";
  event_tic_category: any;
  isFull: any;
  card_data: any;
  scan_type: any;
  barcode: any;

  constructor(
    private service: ServicesService,
    private formbuilder: FormBuilder,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<EditRegistration>,
    @Inject(MAT_DIALOG_DATA) public data: RegData,
  ) {
    this.reg_id = data["reg_id"];
    this.UserForm = this.formbuilder.group({});
  }

  ngOnInit() {
    this.event_id = window.sessionStorage.getItem("Event_ID");
    this.Get_Reg_Setting();
    this.Get_Card(this.event_id);
    this.Get_Tic_Category(this.event_id);
  }

  previewpproof(event: any) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    const mimeType = file.type;
    if (!mimeType.match(/image\/*/)) {
      this.message = "Only images are supported.";
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      this.logofileURL = reader.result;
      this.imgType = this.event_id + "/id_proof";
      this.service
        .uploadimage(this.logofileURL, this.imgType)
        .subscribe((data: any) => {
          this.logoPath = data["image_name"];
        });
    };
  }

  previewpimage(event: any) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    const mimeType = file.type;
    if (!mimeType.match(/image\/*/)) {
      this.message = "Only images are supported.";
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.imgType = this.event_id + "/images";
      this.service
        .uploadimage(this.imagefileURL, this.imgType)
        .subscribe((data: any) => {
          this.imagePath = data["image_name"];
        });
    };
  }

  preview_payment_image(event: any) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    const mimeType = file.type;
    if (!mimeType.match(/image\/*/)) {
      this.message = "Only images are supported.";
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.imgType = this.event_id + "/payment_ss";
      this.service
        .uploadimage(this.imagefileURL, this.imgType)
        .subscribe((data: any) => {
          this.paymentPath = data["image_name"];
        });
    };
  }

  Get_Tic_Category(eventId: any) {
    this.service.get_ticket_category(eventId).subscribe(
      (data: any) => {
        this.event_tic_category = data.data;
        this.isFull = this.event_tic_category.every(
          (item: any) => item.disable_category,
        );
      },
      (error) => {
        console.error("Error fetching ticket categories:", error);
      },
    );
  }

  Get_Reg_Setting() {
    this.Element_Data = [];

    this.service.get_reg_setting(this.event_id).subscribe(
      (data: any) => {
        const regSettings = data.data;
        const formControls: { [key: string]: FormControl } = {};

        regSettings.forEach((item: any) => {
          const isRequired = item.require == 1;
          formControls[item.fields] = new FormControl(
            "",
            isRequired ? Validators.required : null,
          );

          this.Element_Data.push({
            label: item.label,
            fields: item.fields,
            hide_show: item.hide_show == 1,
            require: isRequired,
            type: item.type,
            value: item.value?.toString().trim(),
          });

          if (item.type === "date") {
            const dates = item.value
              .split(" - ")
              .map((date: string) => date.trim());
            if (dates.length === 2) {
              this.minDate = new Date(dates[0]);
              this.maxDate = new Date(dates[1]);
            }
          }
        });

        // formControls['whatsapp_status'] = new FormControl('', Validators.required);
        this.UserForm = this.formbuilder.group(formControls);

        if (this.reg_id) {
          this.Get_Reg_by_id();
        }
      },
      (error) => {
        console.error("Error fetching registration settings:", error);
      },
    );
  }

  Get_Card(event_id: any) {
    this.service.get_card(event_id).subscribe((data: any) => {
      this.card_data = data.data;
      this.scan_type = this.card_data[0].scan_type;
    });
  }

  Get_Reg_by_id() {
    this.service.get_reg_by_id(this.reg_id).subscribe({
      next: (data: any) => {
        if (data && data.data && data.data[0]) {
          const formValues = data.data[0];

          // Map category_id to tic_category
          if (formValues.category_id) {
            formValues.tic_category = formValues.category_id;
          }

          this.UserForm.patchValue(formValues);
          this.barcode = formValues.barcode;
          this.paymentPath = formValues.payment_ss;
          this.logoPath = formValues.id_proof;
          this.imagePath = formValues.image;
          this.whatsapp_status = formValues.whatsapp_status;

          this.UserForm.get("tic_category")?.disable();
        } else {
          console.warn("No data or form values available.");
        }
      },
      error: (error: any) => {
        console.error("Error fetching registration data:", error);
      },
    });
  }

  formatDate(event: any, field: string) {
    if (event) {
      const formattedDate = this.datePipe.transform(event, "yyyy-MM-dd");
      this.UserForm.value[field] = formattedDate; // Assign formatted date
    }
  }

  onSubmit() {
    this.UserForm.value["whatsapp_status"] = this.whatsapp_status;
    this.UserForm.value["barcode"] = this.barcode;

    if (this.UserForm.valid) {
      if (this.reg_id) {
        this.service
          .admin_edit_registration(
            this.UserForm.value,
            this.reg_id,
            this.logoPath,
            this.imagePath,
          )
          .subscribe({
            next: (val: any) => {
              this.toastr.success(val.msg);
              this.dialogRef.close(true);
            },
            error: (err: any) => {
              console.error(err);
            },
          });
      } else {
        this.service
          .admin_add_registration(
            this.UserForm.value,
            this.logoPath,
            this.imagePath,
            this.paymentPath,
          )
          .subscribe({
            next: (val: any) => {
              this.toastr.success(val.msg);
              this.dialogRef.close(true);
            },
            error: (err: any) => {
              console.error(err);
            },
          });
      }
    } else {
      this.toastr.error("Please fill out the form correctly.");
    }
  }
}

@Component({
  selector: "send_card.html",
  templateUrl: "./send_card.html",
  standalone: false,
})
export class SendCard {
  dataSourceData: EventElement[];
  message: any;
  contact_count: any;
  event_id: any;
  private destoryRef = inject(DestroyRef);

  progress = 0;
  successCount = 0;
  totalContacts = 0;

  constructor(
    private service: ServicesService,
    private formbuilder: FormBuilder,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private progressService: WhatsappProgressService,
    private dialogRef: MatDialogRef<SendCard>,
    @Inject(MAT_DIALOG_DATA) public data: { dataSource: EventElement[] },
  ) {
    this.dataSourceData = data.dataSource;
    this.contact_count = this.dataSourceData.length;
  }

  ngOnInit() {
    this.event_id = window.sessionStorage.getItem("Event_ID");
  }

  Send_Message() {
    this.spinner.show();

    if (!this.dataSourceData || this.dataSourceData.length === 0) {
      this.spinner.hide();
      return;
    }

    const totalContacts = this.dataSourceData.length;
    this.progressService.start(totalContacts);

    const batchSize = 5;

    const batches: any[][] = [];
    for (let i = 0; i < totalContacts; i += batchSize) {
      batches.push(this.dataSourceData.slice(i, i + batchSize));
    }

    let successCount = 0;

    const processBatch = (batchIndex: number) => {
      if (batchIndex >= batches.length) {
        this.spinner.hide();
        this.progressService.complete();

        setTimeout(() => {
          this.dialogRef.close(true);
        }, 500);

        return;
      }

      const currentBatch = batches[batchIndex];
      let batchCompleted = 0;

      currentBatch.forEach((send) => {
        // this.service.Generate_Card1(send.mem_id, this.event_id).subscribe({
        //   next: () => {
        this.service
          .Send_Whatsapp(send, this.event_id, this.message)
          .subscribe({
            next: (res: any) => {
              batchCompleted++;

              if (res?.flag === true) {
                successCount++;
                this.progressService.update(successCount, totalContacts);
              }

              checkDone();
            },
            error: () => {
              batchCompleted++;
              checkDone();
            },
          });
        //   },
        //   error: () => {
        //     batchCompleted++;
        //     checkDone();
        //   },
        // });
      });

      const checkDone = () => {
        if (batchCompleted === currentBatch.length) {
          setTimeout(() => {
            processBatch(batchIndex + 1);
          }, 3000);
        }
      };
    };

    const confirmSend = totalContacts > 1
      ? window.confirm("Send to multiple contacts?")
      : true;

    if (confirmSend) {
      processBatch(0);
      this.dialogRef.close(true);
    } else {
      this.spinner.hide();
      this.progressService.reset();
    }
  }

  checkBatchDone(
    batchCompleted: number,
    batchLength: number,
    batchIndex: number,
    processBatch: any
  ) {
    if (batchCompleted === batchLength) {
      console.log(`Batch ${batchIndex + 1} completed`);

      // ⏳ Wait 5 seconds before next batch
      setTimeout(() => {
        processBatch(batchIndex + 1);
      }, 3000);
    }
  }

  updateProgress() {
    this.progress = Math.round(
      (this.successCount / this.totalContacts) * 100
    );
  }
}

@Component({
  selector: "assign_tickets.html",
  templateUrl: "./assign_tickets.html",
  styleUrls: ["./registration-list.component.scss"],
  standalone: false,
})
export class AssignTicket {
  event_id: any;
  ticket_data: any;
  ticket_category_data: any;
  unassigned_tickets_data: any;
  alloted_ticket: any;
  Selected_Tickets: any;
  ticket_name: any;
  allowed_person: any;
  tic_category: any;

  isModalOpen = false;

  selectedTickets: number = 0; // Counter for the selected tickets
  selectedTicketData: any[] = []; // Store selected ticket data

  private destoryRef = inject(DestroyRef);

  constructor(
    private service: ServicesService,
    private formbuilder: FormBuilder,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private dialogRef: MatDialogRef<AssignTicket>,
    @Inject(MAT_DIALOG_DATA) public data: { dataSource: EventElement[] },
  ) {
    this.ticket_data = data;
  }

  ngOnInit() {
    this.event_id = window.sessionStorage.getItem("Event_ID");
    this.Get_Unassigned_Tickets(this.ticket_data);
  }

  async Get_Unassigned_Tickets(user_data: any) {
    this.ticket_name = user_data.name;
    this.allowed_person = user_data.allowed_person;
    this.tic_category = user_data.tic_category;
    this.service
      .get_unassigned_tickets(user_data.mem_id, this.event_id)
      .subscribe((data: any) => {
        this.alloted_ticket = data.alloted ?? false; // Ensure it's defined
        if (this.alloted_ticket == false) {
          // Add `mem_id` to each ticket object
          this.unassigned_tickets_data = data.data.map((ticket: any) => ({
            ...ticket,
            mem_id: user_data.mem_id, // Ensure consistent naming
          }));
        } else {
          this.unassigned_tickets_data = data.data;
        }
      });
  }

  isChecked(data: any): boolean {
    return this.selectedTicketData.includes(data);
  }

  // Method for checkbox change event
  onCheckboxChange(event: any, data: any): void {
    const isChecked = event.checked; // Get the checked state directly from the event object
    if (isChecked) {
      if (this.selectedTickets < this.allowed_person) {
        this.selectedTickets++;
        this.selectedTicketData.push(data);
      } else {
        event.checked = false; // Uncheck the checkbox if the limit is exceeded
      }
    } else {
      this.selectedTickets--;
      this.selectedTicketData = this.selectedTicketData.filter(
        (ticket) => ticket !== data,
      );
    }
  }

  Assign_Ticket() {
    if (this.selectedTickets < this.allowed_person) {
      // alert('Error', `Please select ${this.allowed_person} tickets.`);
      return; // Prevent further execution if condition is not met
    }

    let completedRequests = 0;

    // Loop through the Selected_Tickets array and send each ticket individually to the backend
    for (const ticket of this.selectedTicketData) {
      this.service.assign_ticket(ticket).subscribe(
        (data: any) => {
          completedRequests++;
          // If all tickets have been processed, show the alert and close the modal
          if (completedRequests === this.selectedTicketData.length) {
            this.toastr.success("Success", "Tickets assigned successfully");
            this.dialogRef.close(true);
          }
        },
        (error: any) => {
          console.error("Error assigning ticket:", ticket, "Error:", error); // Handle any error for each ticket

          completedRequests++;

          // Even if there was an error, check if all requests are done
          if (completedRequests === this.selectedTicketData.length) {
            this.toastr.error("Error", "Some tickets could not be assigned");
            this.dialogRef.close(true);
          }
        },
      );
    }
  }
}

@Component({
  selector: "add_registration.html",
  templateUrl: "./add_registration.html",
  styleUrls: ["./registration-list.component.scss"],
  standalone: false,
})
export class add_registration {
  isIframeVisible = true; // Track visibility of the iframe
  result: any;
  main: any;
  user_id: any;
  event_id: any;
  refercode: any;
  iframeSrc!: SafeUrl;
  constructor(
    private service: ServicesService,
    private sanitizer: DomSanitizer,
  ) { }

  closeIframe() {
    this.isIframeVisible = false; // Set to false to hide the iframe
    window.location.reload();
  }

  ngOnInit() {
    this.user_id = sessionStorage.getItem("User_ID");
    this.event_id = sessionStorage.getItem("Event_ID");
    this.getUserById(this.user_id);
  }

  getUserById(user_id: any) {
    this.service.get_user_by_id(user_id).subscribe((data: any) => {
      this.result = data;
      this.main = this.result.data;
      console.log(this.main[0].refercode);

      this.refercode = this.main?.[0].refercode;
      this.openIframe(this.refercode);
    });
  }

  openIframe(refercode: any) {
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://aieventzo.com/scan-me/#/Registration/${this.event_id}/${this.refercode}/${this.user_id}`,
    );
    console.log(
      `https://aieventzo.com/scan-me/#/Registration/${this.event_id}/${this.refercode}/${this.user_id}`,
    );
  }
}

@Component({
  selector: "cash_pay.html",
  templateUrl: "./cash_pay.html",
  styleUrls: ["./registration-list.component.scss"],
  standalone: false,
})
export class CashPay {
  dataSourceData: EventElement[];
  totalAmount: any;
  reg_fee_is_approved: any;
  event_id: any;
  mem_id: any;
  result: any;
  main: any;
  send_whatsapp_reg: any;
  reg_whatsapp_msg: any;
  name: any;
  mobile: any;
  email: any;
  payment_data: any;

  constructor(
    private service: ServicesService,
    private formbuilder: FormBuilder,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private dialogRef: MatDialogRef<SendCard>,
    @Inject(MAT_DIALOG_DATA) public data: { dataSource: EventElement[] },
  ) {
    this.dataSourceData = data.dataSource;
    this.mem_id = this.dataSourceData;
    console.log(this.mem_id);
  }

  ngOnInit() {
    this.event_id = window.sessionStorage.getItem("Event_ID");
    this.getRegFee(this.mem_id, this.event_id);
  }

  getRegFee(mem_id: any, event_id: any) {
    this.service.get_reg_fee(mem_id, event_id).subscribe((data: any) => {
      this.result = data;
      this.totalAmount = this.result.amount;
      this.name = this.result.name;
      this.mobile = this.result.mobile;
      this.email = this.result.email;
      this.reg_fee_is_approved = this.result.reg_fee_is_approved;

      if (this.reg_fee_is_approved == 1) {
        alert("Payment is Already Done.");
        this.dialogRef.close(false); // close dialog
      }
    });
  }

  payCash() {
    const now = new Date();
    const created_at =
      now.getFullYear() +
      "-" +
      String(now.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(now.getDate()).padStart(2, "0");

    this.payment_data = {
      amount: this.totalAmount,
      order_id: "", // or null if not needed
      status: "captured", // important (authorized / captured)
      method: "cash",
      mem_id: this.mem_id,
      event_id: this.event_id,
      name: this.name,
      mobile: this.mobile,
      created_at: created_at,
    };

    this.service.cash_payment(this.payment_data).subscribe((data: any) => {
      this.service.getsetting(this.event_id).subscribe((data: any) => {
        this.send_whatsapp_reg = data.data[0].send_whatsapp_reg;
        this.reg_whatsapp_msg = data.data[0].reg_whatsapp_msg;

        if (this.send_whatsapp_reg == "yes") {
          this.service
            .Generate_Card1(this.mem_id, this.event_id)
            .subscribe(() => {
              const whatsapp_data = {
                mem_id: this.mem_id,
                name: this.name,
                mobile: this.mobile,
                email: this.email,
              };
              this.service
                .Send_Whatsapp(
                  whatsapp_data,
                  this.event_id,
                  this.reg_whatsapp_msg,
                )
                .subscribe(() => {
                  console.log("SUCCESS: ID CARD SENT ON WHATSAPP");
                  // this.navigateToRegistrationPage();
                });
            });
        } else {
          console.log("SUCCESS");
          // this.navigateToRegistrationPage();
        }
      });
    });
  }
}
